import { render, staticRenderFns } from "./select-menu.vue?vue&type=template&id=1d8e227a&scoped=true&"
import script from "./select-menu.vue?vue&type=script&lang=js&"
export * from "./select-menu.vue?vue&type=script&lang=js&"
import style0 from "./select-menu.vue?vue&type=style&index=0&id=1d8e227a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e227a",
  null
  
)

export default component.exports